import { useI18n } from '../i18n';

export function Placeholder({ title }: { title: string }) {
  const { t } = useI18n();
  return (
    <section className="panel" style={{ marginTop: 24 }}>
      <h2>{title}</h2>
      <p className="muted" style={{ margin: 0 }}>{t('placeholder.text', { step: t('placeholder.next') })}</p>
    </section>
  );
}
